import React from 'react';
import { Collapse } from 'react-bootstrap';
import { MedFormInOrderSet } from '../../../../../components/Users/MedForm';
import { useForm } from 'react-hook-form';
import type { Medication } from '../../../../../../lib/transferObjects/Medication';

export const MedicationForm = ({
  open,
  onClose,
  medicationProfileForm,
  onSave,
  medication,
  currentSection,
  readOnly = false,
}: {
  open: boolean;
  onClose: () => void;
  medicationProfileForm: any;
  onSave: (data: any, targetSection: string) => void;
  medication: Medication;
  currentSection: string;
  readOnly?: boolean;
}) => {
  const { watch } = medicationProfileForm;
  const sectionsData = watch('medSections');
  const sectionOptions = sectionsData.map((section: any) => ({
    value: section.medSectionBreak,
    label: section.medSectionBreak,
  }));

  const medForm = useForm({
    defaultValues: {
      ...medication,
    },
  });

  return (
    <Collapse
      in={open}
      onEntered={() =>
        window.dispatchEvent(new Event('caremappr:collapse-entered'))
      }
    >
      <div>
        <div className="px-2 d-flex flex-column gap-2">
          <span className="my-2 medication-profile-font-gray row-action-font">
            {readOnly ? 'Medication Details' : 'Edit Medication Form'}
          </span>
          <MedFormInOrderSet
            data={medication}
            sectionOptions={sectionOptions}
            onOrderSetModeChange={(data: any) => {
              onClose();
              onSave(data, currentSection);
              medForm.reset();
              onClose();
            }}
            onCancelEdit={() => {
              medForm.reset();
              onClose();
            }}
            showFurtherInform={false}
            showSection={false}
            readOnly={readOnly}
          />
        </div>
      </div>
    </Collapse>
  );
};
export const EditMedicationForm = MedicationForm;
